import { createContext, useContext } from 'react';

export interface ToastApi {
  push: (t: { title: string; description?: string; tone: 'success' | 'error' | 'info' }) => void;
  success: (title: string, description?: string) => void;
  error: (title: string, description?: string) => void;
}

export const ToastContext = createContext<ToastApi | null>(null);

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast fuera de ToastProvider');
  return ctx;
}
